import React from "react";
import { bool, node } from "prop-types";
import SimpleTemplate from "@insightfulscience/atomic-react/SimpleTemplate";
import Section from "@insightfulscience/atomic-react/Section";
import { bgColor4 } from "@insightfulscience/atomic-react/utils/color";
import SiteLayout from "../SiteLayout";

/** @type {React.FC<{ children: React.ReactNode, extra: React.ReactNode }>} */
const ErrorLayout = ({ children, extra }) => (
	<SiteLayout>
		<SimpleTemplate shadow={false} bgColor={bgColor4}>
			{children}
		</SimpleTemplate>
		{extra && <Section className="pt-9 pt-9--md pb-18 pb-18--md">{extra}</Section>}
	</SiteLayout>
);

ErrorLayout.propTypes = {
	children: node,
	extra: node,
};

/** @type {React.FC<{ children: React.ReactNode, extra: React.ReactNode, isAuthorized: boolean }>} */
const ErrorLayoutPure = ({ children, extra, isAuthorized }) => (
	<SiteLayout.Pure isAuthorized={isAuthorized}>
		<SimpleTemplate shadow={false} bgColor={bgColor4}>
			{children}
		</SimpleTemplate>
		{extra && <Section className="pt-9 pt-9--md pb-18 pb-18--md">{extra}</Section>}
	</SiteLayout.Pure>
);

ErrorLayoutPure.propTypes = {
	...ErrorLayout.propTypes,
	isAuthorized: bool,
};

ErrorLayout.Pure = ErrorLayoutPure;

export default ErrorLayout;
